// @ts-nocheck
import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import useHttpClient from "../useHttpClient";
import { AxiosError, AxiosInstance } from "axios";

const usePhoneLogin = (): SWRMutationResponse<any, AxiosError, string> => {
  const httpClient: AxiosInstance = useHttpClient();
  return useSWRMutation(
    "phone-login",
    async (key, { arg }: { arg: string }): Promise<any> =>
      httpClient.post("/auth/login/phone", { phoneNumber: arg }).then((res) => res.data)
  );
};

export default usePhoneLogin;
